var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from '@angular/core';
import { AppConstant } from '../app.constant';
import { AuthService } from '../common/auth.service';
import { Router } from '@angular/router';
import { StartupService } from '../common/startup.service';
var NavbarComponent = /** @class */ (function () {
    function NavbarComponent(authS, router, startup) {
        this.authS = authS;
        this.router = router;
        this.startup = startup;
        this.AuthUrl = AppConstant.PERMISSION;
        this.activeRoute = this.router.url;
        this.activeRouteStatus = localStorage.getItem('activeRouteStatus');
        this.domainName = this.startup.reseller;
        if (Number(this.activeRouteStatus) === 1) {
            this.disabled = true;
            if (this.activeRoute !== '/settings/billing') {
                this.router.navigate(['/settings/billing']);
            }
        }
        else {
            this.disabled = false;
            this.router.navigate([this.activeRoute]);
        }
    }
    NavbarComponent.prototype.ngOnInit = function () {
        this.managerText = localStorage.getItem('appManagerText');
        this.merchantText = localStorage.getItem('appMerchantText');
        this.agentText = localStorage.getItem('appAgentText');
        this.isFavouriteLocationEnabled = localStorage.getItem('isFavouriteLocationEnabled') === 'true' ? true : false;
        this.isPartner = localStorage.getItem('isPartner') === 'true' ? true : false;
        this.isMerchantEnable = localStorage.getItem('isMerchantEnable') === 'true' ? true : false;
        this.isNavigateDashbordOrTask = localStorage.getItem('isNavigateDashbordOrTask') === 'true' ? true : false;
        this.isMerchantPricingEnable = localStorage.getItem('isMerchantPricingEnable') === 'true' ? true : false;
        this.isProjectEnabled = (localStorage.getItem('isProjectEnabled')) === 'true' ? true : false;
        this.role = localStorage.getItem('role') === '1' ? 1 : 2;
    };
    NavbarComponent.prototype.hasAccess2 = function (url) {
        this.allowAccessAsAdmin = localStorage.getItem('allowAccessAsAdmin') === 'true' ? true : false;
        if (this.allowAccessAsAdmin === true) {
            return false;
        }
        else {
            return this.authS.hasAccess(url);
        }
    };
    NavbarComponent.prototype.hasAccess = function (url) {
        return this.authS.hasAccess(url);
    };
    NavbarComponent = __decorate([
        Component({
            selector: 'app-navbar',
            template: require("./navbar.component.html"),
            styles: [require("./navbar.component.scss"), require(".././global-css/global.component.scss"), require(".././global-css/fonts/font/flaticon.css"), require(".././global-css/global.responsive.scss")]
        }),
        __metadata("design:paramtypes", [AuthService, Router, StartupService])
    ], NavbarComponent);
    return NavbarComponent;
}());
export { NavbarComponent };



//////////////////
// WEBPACK FOOTER
// ./src/app/navbar/navbar.component.ts
// module id = ./src/app/navbar/navbar.component.ts
// module chunks = main